import React, { useMemo } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import * as Typo from './Typo';

const createWrappedChildren = (children, Component, parentProps) => props => {
  const [_children, _title] = useMemo(() => {
    const _children = React.Children.map(children, (child: React.ReactElement<any>, key) =>
      child.type.name === Redirect.name
      && React.cloneElement(child, {
        key,
        from: props.match.url + (child.props.from || ''),
        to: props.match.url + child.props.to
      })
      || React.cloneElement(child, { key, path: props.match.url + child.props.path })
    );

    const matchedRoute:any = React.Children.toArray(children).filter((child: any) =>
      child.props.exact
      ? props.location.pathname === child.props.path
      : props.location.pathname.includes(child.props.path && child.props.path.split(':')[0])
    );

    return [_children, matchedRoute.length && matchedRoute[matchedRoute.length-1].props.title];
  }, [props.location]);


  return <Component {...props} {...parentProps} children={_children} title={_title} />
}

const createSimpleChildren: any = (children) => (props) => {
  const _children = useMemo(() => React.Children.map(children, (child: any) =>
    child.props.path
      ? React.cloneElement(child, { path: props.match.url + child.props.path })
      : React.cloneElement(child, { to: props.match.url + child.props.to })
  ), []);

  return <Switch {...props} children={_children} />
};

export default ({ children, component, ...props }: any) => {
  const _component = useMemo(() =>
    component ? createWrappedChildren(children, component, props) : createSimpleChildren(children, props)
  , []);

  return <Route {...props} component={_component} />
};

export { Content } from './Content';
export { Box } from './Box';
export { Divider } from './Divider';
export { List } from './List';
export { Grid } from './Grid';
export { Info } from './Info';
export { Badge } from './Badge';
export { Body } from './Body';
export { Header } from './Header';
export { Footer } from './Footer';
export { Block } from './Block';
export { PageTitle } from './PageTitle';
export { Rhythm } from './Rhythm';
export { Typo };
